export const environment = {
    production: false,
    envName: "dev",
    autoSignIn: true,
    popupForLogin: false,
    cacheLocation: "localStorage",
    instance: "https://login.microsoftonline.com/",
    tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    clientId: '572f5798-4652-4ce1-81a2-0245cfad8e19',
    redirectUri: 'https://fluidsys-app-dev.azure.chevron.com',
    oidcScopes: ["openid", "profile", "User.Read","offline_access"],
    graphScopes: ["User.Read", "User.Read.All", "Group.Read.All"],
    appApiURL: 'https://fluidsys-api-dev.azure.chevron.com/api/v1/',
    graphApiURL: 'https://graph.microsoft.com',
};
